/*global window*/
import $ from "jquery";
import ajax from "ajax";
import modal from "modal";

function updateWildcardPrograms(requestData) {
  ajax.stream({
    url: '/ohjelmaopas/api/record/wildcard/matches',
    type: 'GET',
    dataType: 'json',
    data: {
      channelId: requestData.channelId,
      wildcard: requestData.wildcard
    }
  })
    .onValue(function (data) {
      for (var i in data) {
        if (data.hasOwnProperty(i)) {
          var program = data[i];
          updateRecording(program);
        }
      }
    });
}

function updateRecording(program) {
  $('.tv-program[data-id=' + program.id + ']').each(function () {
    var $element = $(this);
    var $recIcons = $element.find('.recording-icons');
    var $qrec = $element.find('.haku-qrec');
    if (program.recording) {
      $element.attr("data-recording-id", program.recording.id);
      $qrec.toggleClass('quick-rec active', false);
      $recIcons.toggleClass('record', true);
      if (program.recording.rule) {
        $element.attr("data-recording-rule", program.recording.rule);
        $element.attr("data-recording-rule-id", program.recording.ruleId);
        $recIcons.toggleClass('wildcard', true);
      }
    } else {
      $element.removeAttr("data-recording-id data-recording-rule data-recording-rule-id");
      $recIcons.toggleClass('wildcard record', false);
      $qrec.toggleClass('quick-rec active', true);
    }
  });
}

function updatePrograms(jsonData) {
  var program;
  for (var i in jsonData) {
    if (jsonData.hasOwnProperty(i)) {
      program = jsonData[i];
      updateRecording(program);
    }
  }
}

function updateSearchAfterRecording(requestData, responseData) {
  if (requestData.wildcard) {
    updateWildcardPrograms(requestData, responseData);
  } else {
    updatePrograms(responseData);
  }
  modal.close();
}

export default {
  updateSearchAfterRecording: updateSearchAfterRecording
};



// WEBPACK FOOTER //
// ./web/js/search.js